export default "__VITE_ASSET__N_qvr32b__"